import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { KnBrCartEffects } from './kn-br-cart.effects';

@NgModule({
  imports: [EffectsModule.forFeature([KnBrCartEffects])],
})
export class KnBrCartStateModule {}
